import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import serviceConfig from '../service-config';
import { Observable } from 'rxjs';
import { AppState } from '../../core/reducers/index';
import { Store } from '@ngrx/store';
import { selectAuthState } from '../../core/auth/_selectors/auth.selectors';

@Injectable({
  providedIn: 'root'
})
export class AgentsService {

  uri = serviceConfig.altBaseUrl;
  headers: HttpHeaders;

  
  constructor(private http:HttpClient, private store: Store<AppState> ) { 
    this.store.select(selectAuthState).subscribe((result) => {   
      this.headers = new HttpHeaders()
                          .append('Authorization', "Bearer " + result.authToken)  
                          .append('Content-Type', 'application/json')
                          .append('accept','*/*')
                          .append('accept','text/plain');
    });
  }

  getAgentsByRegimen(regimen:string) : Observable<any> {
    let url = this.uri + serviceConfig.endPoints.getAgents;
    return this
      .http
      .get<any>(`${url}?regimen=${regimen}`,
       { headers: this.headers });

  }

  getAgentsbyRegimen(regimen:string) : Observable<any> {
    let url = this.uri + serviceConfig.endPoints.getAgents;    
    return this
      .http
      .get<any>(`${url}?clienteId=${regimen}`,
       { headers: this.headers });

  }
}
